var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeTipsMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_930_148675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 7,
    width: 41,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 7H4V42H45V7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_930_148675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7439 37.9196L29.2771 26.4528M18.7371 26.4379L8.74546 36.4295",
    stroke: "#00D1D2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6038 14.8799C37.8478 17.636 33.8563 21.8214 28.3442 27.3335C25.3953 30.2824 22.3389 29.7896 19.7432 27.194C14.3194 21.7702 10.2516 17.7024 7.5397 14.9905L7.53412 12.2736L40.5903 12.4595L40.6038 14.8799Z",
    stroke: "#34303D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6577 38.1895H13.4674C9.2502 38.1895 7.41712 35.6821 7.41712 32.0147C7.41712 18.9187 7.41712 12.3707 7.41712 12.3707C7.41712 12.3707 39.9101 12.3722 40.6577 12.3722V38.1895Z",
    stroke: "#34303D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeTipsMail);
export default __webpack_public_path__ + "static/media/welcome-tips-mail.17412f9a26e4f4336733a4e581b03b48.svg";
export { ForwardRef as ReactComponent };